import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_SERVICE_URL;
const rooted = process.env.REACT_APP_BACKEND_HR_URL;

/**ALL API CALL FUNCTIONS EXPORTED AS AN OBJECT OF METHODS */

const PaymentServiceSetup = () => {
  const route = api(root);
  const routed = api(rooted);

  return {
    CreatePaymentSetup: function (data) {
      return route.post(`/PaymentSetupClass`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    CreatePaymentSubclass: function (data) {
      return route.post(`/PaymentSetupSubClass`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    CreatePaymentSetupLimit: function (data) {
      return route.post(`/PaymentSetupLimit`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    CreatePaymentSubclassComponent: function (data) {
      return route.post(`/PaymentSetupComponent`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdatePaymentSetup: function (data) {
      return route.post(`/PaymentSetupClass/update`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdatePaymentSubclass: function (data) {
      return route.post(`/PaymentSetupSubClass/update`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdatePaymentSubclassComponent: function (data) {
      return route.post(`/PaymentSetupComponent/update`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    UpdatePaymentLimit: function (data) {
      return route.post(`/PaymentSetupLimit/update`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    DisableClass: function (data) {
      return route.post(`/PaymentSetupClass/delete`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    DisableSubClass: function (data) {
      return route.post(`/PaymentSetupSubClass/delete`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    DisableSubComponent: function (data) {
      return route.post(`/PaymentSetupComponent/delete`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    DisablePaymentLimit: function (data) {
      return route.post(`/PaymentSetupLimit/delete`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },

    GetAllPaymentService: function (data) {
      const { search, pageSize, pageNumber } = data;
      return !search
        ? route.get(
            `/PaymentSetupClass/all?PageSize=${pageSize}&PageNumber=${pageNumber}`
          )
        : route.get(
            `/PaymentSetupClass/all?Search=${search}&PageSize=${pageSize}&PageNumber=${pageNumber}`
          );
    },

    GetAllPaymentSubclass: function (data) {
      const { search, pageSize, pageNumber } = data;
      return !search
        ? route.get(
            `/PaymentSetupSubClass/all?PageSize=${pageSize}&PageNumber=${pageNumber}`
          )
        : route.get(
            `/PaymentSetupSubClass/all?Search=${search}&PageSize=${pageSize}&PageNumber=${pageNumber}`
          );
    },

    GetAllPaymentSubclassComp: function (data) {
      const {
        search,
        filters,
        startDate,
        endDate,
        pageSize,
        pageNumber,
        PaymentSetupSubClassId,
      } = data;

      // Create an array to hold the query parameters
      const queryParams = [];

      // Add parameters to the array only if they are provided
      if (search) {
        queryParams.push(`Search=${encodeURIComponent(search)}`);
      }
      if (filters) {
        queryParams.push(`Filters=${encodeURIComponent(filters)}`);
      }
      if (startDate) {
        queryParams.push(`StartDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        queryParams.push(`EndDate=${encodeURIComponent(endDate)}`);
      }
      if (pageSize) {
        queryParams.push(`PageSize=${pageSize}`);
      }
      if (pageNumber) {
        queryParams.push(`PageNumber=${pageNumber}`);
      }
      if (PaymentSetupSubClassId) {
        queryParams.push(`PaymentSetupSubClassId=${PaymentSetupSubClassId}`);
      }

      // Join the parameters with '&' and construct the final URL
      const queryString =
        queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

      // Make the GET request with the constructed URL
      return route.get(`/PaymentSetupComponent/all${queryString}`);
    },

    GetAllPaymentCashAdvance: function (data) {
      const {
        search,
        filters,
        startDate,
        endDate,
        pageSize,
        pageNumber,
        PaymentSetupSubClassId,
      } = data;

      // Create an array to hold the query parameters
      const queryParams = [];

      // Add parameters to the array only if they are provided
      if (search) {
        queryParams.push(`Search=${encodeURIComponent(search)}`);
      }
      if (filters) {
        queryParams.push(`Filters=${encodeURIComponent(filters)}`);
      }
      if (startDate) {
        queryParams.push(`StartDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        queryParams.push(`EndDate=${encodeURIComponent(endDate)}`);
      }
      if (pageSize) {
        queryParams.push(`PageSize=${pageSize}`);
      }
      if (pageNumber) {
        queryParams.push(`PageNumber=${pageNumber}`);
      }
      if (PaymentSetupSubClassId) {
        queryParams.push(`PaymentSetupSubClassId=${PaymentSetupSubClassId}`);
      }

      // Join the parameters with '&' and construct the final URL
      const queryString =
        queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

      // Make the GET request with the constructed URL
      return routed.get(`/PaymentRequisition/myCashAdvance${queryString}`);
    },

    GetAllPaymentLimit: function (data) {
      const { search, pageSize, pageNumber } = data;
      return !search
        ? route.get(
            `/PaymentSetupLimit/all?PageSize=${pageSize}&PageNumber=${pageNumber}`
          )
        : route.get(
            `/PaymentSetupLimit/all?Search=${search}&PageSize=${pageSize}&PageNumber=${pageNumber}`
          );
    },

    GetAllPaymentServiceHistory: function (data) {
      const { search, startDate, endDate, pageSize, pageNumber } = data;
      return route.get(
        `/PaymentServiceRequestHistory/PaymentServiceRequestHistory?Search=${
          search || ""
        }&PageSize=${pageSize}&PageNumber=${pageNumber}&StartDate=${
          startDate || ""
        }&EndDate=${endDate || ""}`
      );
      // return !search
      //   ? route.get(
      //       `/PaymentSetupComponent/all?PageSize=${pageSize}&PageNumber=${pageNumber}`
      //     )
      //   : route.get(
      //       `/PaymentSetupComponent/all?Search=${search}&PageSize=${pageSize}&PageNumber=${pageNumber}`
      //     );
    },

    GetAllCadrePosition: function (data) {
      const { pageSize, pageNumber } = data;

      return routed.get(
        `/EmployeeCadrePosition/alllevel?Status=0&PageSize=${pageSize}&PageNumber=${pageNumber}`
      );
    },

    GetPaymentServiceByID: function (data) {
      return route.get(`/PaymentSetupClass/${data}?Id=${data}`);
    },
    GetPaymentSubclassByID: function (data) {
      return route.get(`/PaymentSetupSubClass/${data}?Id=${data}`);
    },
    GetPaymentSubclassCompByID: function (data) {
      return route.get(`/PaymentSetupComponent/${data}?Id=${data}`);
    },
  };
};

export const PaymentService = {
  PaymentServiceSetup: PaymentServiceSetup,
};
